import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { WorkspacePremiumOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { usePlan, PLAN_RANK } from '../../hooks/usePlan';
import { ChapterPlan } from '../../types/membership';

interface RequirePlanProps {
  /** Minimum plan tier required. Tiers are ordered (free < plus < managed). */
  plan: ChapterPlan;
  /** Child content to render if the chapter's plan meets the requirement. */
  children: React.ReactNode;
}

const UpgradeRequired = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        gap: 2
      }}>
      <WorkspacePremiumOutlined sx={{ fontSize: 64, color: 'text.disabled' }} />
      <Typography variant="h5">Upgrade Required</Typography>
      <Typography variant="body1" sx={{
        color: "text.secondary"
      }}>
        This feature requires an upgraded MyGreek plan.
      </Typography>
      <Button variant="outlined" onClick={() => navigate('/chapter?tab=plan')}>
        View Your Plan
      </Button>
    </Box>
  );
};

const RequirePlan: React.FC<RequirePlanProps> = ({ plan, children }) => {
  const { effectivePlan, loading } = usePlan();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (PLAN_RANK[effectivePlan] < PLAN_RANK[plan]) {
    return <UpgradeRequired />;
  }

  return <>{children}</>;
};

export default RequirePlan;
